import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { RtfmDerivedState } from "../hooks/useRtfmLifecycle";
import { ButtonSimple } from "./RtfmDemoApp";
import { twMerge } from "tailwind-merge";
import { RtfmAppState } from "@/hooks/useRtfmAppState";

interface EndScreenProps {
    state: RtfmAppState;
    derived: RtfmDerivedState;
    didStartExperience: boolean;
}

export const EndScreen = ({
    state,
    derived,
    didStartExperience,
}: EndScreenProps) => {
    return (
        <div className={twMerge(
            "relative w-full flex flex-row items-center justify-between mt-2 gap-2 whitespace-nowrap",
            derived.isPost && "opacity-100 pointer-events-auto",
            !derived.isPost && "opacity-0 pointer-events-none"
        )}>
            <p>
                see you explorer...
            </p>
            <div className="flex flex-row items-center justify-center gap-2 h-8">
                <a href="https://worldlabs.ai" target="_blank" rel="noopener noreferrer">
                    <ButtonSimple className="w-min">
                        <p className="whitespace-nowrap">worldlabs.ai</p>
                        <ExternalLinkIcon className="w-3 h-3" />
                    </ButtonSimple>
                </a>
            </div>
            {state.queueStatus === "expired" && !didStartExperience && (
                <div className="absolute -bottom-12 h-8 w-full flex flex-col justify-center lowercase items-center translate-y-1/2 mt-12 pointer-events-none opacity-100">
                    <p className=" bg-red-400/10 text-red-500 text-center p-1 w-[12em]">queue error</p>
                </div>
            )}
        </div>
    );
};
